export default __webpack_public_path__ + "static/ly-15013412cc0a70d05eaa769304cb505f.svg";